/**
 * Un campo del checkout: etiqueta, control y error.
 *
 * Existe para que la relacion entre las tres partes se escriba UNA vez. Un
 * formulario de checkout tiene quince campos, y quince oportunidades de olvidar
 * el `htmlFor`, el `aria-invalid` o el `aria-describedby` que hacen que un
 * lector de pantalla anuncie el error junto al campo que lo produjo.
 *
 * El error se muestra solo cuando el campo ya fue tocado: marcar en rojo un
 * campo que la persona todavia no llena es regañarla por no haber terminado.
 * Quien decide eso es la pantalla, que pasa `error` ya filtrado.
 */
import type { ReactNode } from 'react';

import { Icono } from '../comunes/Icono';

interface Props {
  id: string;
  etiqueta: string;
  error?: string | undefined;
  ayuda?: string;
  /** El control recibe los `aria-*` que lo enlazan con la etiqueta y el error. */
  children: (atributos: {
    id: string;
    'aria-invalid': boolean;
    'aria-describedby': string | undefined;
  }) => ReactNode;
}

export function Campo({ id, etiqueta, error, ayuda, children }: Props) {
  const idError = `${id}-error`;
  const idAyuda = `${id}-ayuda`;
  const descripcion = error !== undefined ? idError : ayuda !== undefined ? idAyuda : undefined;

  return (
    <div className={`campo${error !== undefined ? ' con-error' : ''}`}>
      <label htmlFor={id}>{etiqueta}</label>

      {children({ id, 'aria-invalid': error !== undefined, 'aria-describedby': descripcion })}

      {error !== undefined ? (
        <p className="campo-error" id={idError}>
          <Icono nombre="alerta" />
          {error}
        </p>
      ) : ayuda !== undefined ? (
        <p className="campo-ayuda" id={idAyuda}>
          {ayuda}
        </p>
      ) : null}
    </div>
  );
}
